// to replace require_tree
require('./stores/param_store');
require('./stores/facet');
require('./stores/facet_store');
require('./stores/panel_store');
require('./stores/route_store');
require('./stores/search_results_loader');
require('./stores/search_store');
require('./stores/search_tab_store');
